<template>
  <div class="work_page">
    <v-row>
      <v-col class="space_menu menu1">
        <div class="space_name">工作空间</div>
        <div class="space_contents">
          <v-tabs
            active-class="active"
            background-color="accent-4"
            @change="tabsChange"
          >
            <v-tab key="1" class="mytheme">我的工作空间</v-tab>
            <v-tab key="2">来自分享的工作空间</v-tab>
            <v-tab key="3" class="industry"
              ><b class="line"></b><i class="icon"></i>行业专题库</v-tab
            >
            <v-tab key="4">收藏的专题库</v-tab>
            <v-tab-item key="1">
              <div class="space_right">
                <div class="top_filter">
                  <div class="side1">
                    <v-select
                      :items="spaceItems"
                      label=""
                      @change="spaceChange"
                      v-model="spaceSort"
                      item-text="label"
                      item-value="value"
                      :dense="true"
                      outlined
                    >
                    </v-select>
                  </div>
                  <div class="side2 table"  v-if="view == 'list'" @click="view = 'imgs'">
                    <i class="icon"></i>
                  </div>
                  <div class="side2 img"  v-if="view == 'imgs'" @click="view = 'list'">
                    <i class="icon"></i>
                  </div>
                </div>
                <div class="default_empty" v-if="list.length <= 0">
                  <div class="img"></div>
                  <div class="default_text">
                    工作空间空空如也，点击下方按钮增添内容吧！
                  </div>
                  <div class="default_btn" @click="addNew">
                    <v-icon>mdi-plus</v-icon>
                    <span class="text">新建工作空间</span>
                  </div>
                </div>
                <div class="space_content" v-if="list.length > 0">
                  <div class="nav_top_wrapper">
                    <div class="left_btn" @click="addNew">
                      <v-icon>mdi-plus</v-icon>
                      <span class="text">新建工作空间</span>
                    </div>
                    <div :class="{'right_filter': true,'active': active}">
                      <div class="search_inputs" v-if="false">
                        <v-text-field
                          outlined
                          v-model="spaceKey"
                          :dense="true"
                          hide-details
                          placeholder="搜索工作空间内容"
                          clearable
                          @focus="active = true"
                          @blur="active = false"
                        ></v-text-field>
                      </div>
                      <span class="search_btn" v-if="false" @click="spaceChange"><i class="icon"></i></span>
                    </div>
                  </div>
                  <div class="content_list" v-if="view == 'imgs'">
                    <div class="card_list">
                      <div
                        class="card_item_wrapper"
                        v-for="(item, index) in list"
                        :key="index"
                      >
                        <div class="item">
                          <div class="grey_bg"></div>
                          <div class="top_side">
                            <img
                              src="../../assets/images/common/card_side.svg"
                              alt=""
                            />
                          </div>
                          <div class="cons">
                            <div class="top_cons">
                              <div
                                @click="goDetail(item.id)"
                                :class="['icon_img hand', 'icon' + item.iconImageId]"
                              ></div>
                              <div class="text_wrapper">
                                <div class="tit overflow2 hand" @click="goDetail(item.id)">
                                  {{ item.name }}
                                </div>
                                <div class="bottom_cons">
                                  <div class="more_btn">
                                    <div class="item1">
                                      <v-icon>mdi-folder-open</v-icon
                                      ><span>{{ item.folderNumber }}</span>
                                    </div>
                                    <div class="item1">
                                      <v-icon>mdi-eye</v-icon
                                      ><span>{{ item.viewNumber }}</span>
                                    </div>
                                    <div class="item1">
                                      <v-icon>mdi-share</v-icon
                                      ><span>{{ item.shareNumber }}</span>
                                    </div>
                                  </div>
                                  <div class="more_point">
                                    <i class="icon"></i>
                                    <div class="pop_center_wrapper">
                                      <div
                                        class="list_item edit"
                                        @click="editSpace(item)"
                                      >
                                        <span class="icon"></span>
                                        <span class="text">编辑</span>
                                      </div>
                                      <div
                                        class="list_item del"
                                        @click="deleteSpace(item.id)"
                                      >
                                        <span class="icon"></span>
                                        <span class="text">删除</span>
                                      </div>
                                      <div
                                        class="list_item del"
                                        @click="shareSpace(item)">
                                        <v-icon>mdi-share-variant-outline</v-icon>
                                        <span class="text">分享</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="bottom_cons">
                              <div class="line"></div>
                              <div class="tips_cons">
                                <span class="text1 tit_overflow"
                                  >最新更新于{{
                                    timeFormat(item.updatedAt)
                                  }}</span
                                >
                                <span class="text">
                                  {{ item.docNumber }}条专利
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_list" v-else>
                    <v-data-table
                      item-key="id"
                      :headers="headers"
                      :items="list"
                      hide-default-footer
                      class="elevation-1"
                    >
                      <template v-slot:item.name="{ item }">
                        <div class="tit_overflow" @click="goDetail(item.id)">
                          {{item.name}}
                        </div>
                      </template>
                      <template v-slot:item.description="{ item }">
                        <div class="tit_overflow" @click="goDetail(item.id)">
                          {{item.description}}
                        </div>
                      </template>
                      <template v-slot:item.docNumber="{ item }">
                        <div class="tit_overflow" @click="goDetail(item.id)">
                          {{item.docNumber}}
                        </div>
                      </template>
                      <template v-slot:item.folderNumber="{ item }">
                        <div class="tit_overflow" @click="goDetail(item.id)">
                          {{item.folderNumber}}
                        </div>
                      </template>
                      <template v-slot:item.viewNumber="{ item }">
                        <div class="tit_overflow" @click="goDetail(item.id)">
                          {{item.viewNumber}}
                        </div>
                      </template>
                      <template v-slot:item.shareNumber="{ item }">
                        <div class="tit_overflow" @click="goDetail(item.id)">
                          {{item.shareNumber}}
                        </div>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <div v-if="item" class="icon_list">
                          <v-icon @click="editSpace(item)">mdi-pencil</v-icon>
                          <v-icon @click="shareSpace(item)"
                            >mdi-share-variant</v-icon
                          >
                          <v-icon @click="deleteSpace(item.id)"
                            >mdi-delete</v-icon
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item key="2">
              <div class="space_right">
                 <div class="top_filter">
                  <div class="side1" v-if="false">
                      <v-select
                        :items="viewItem"
                        label=""
                        v-model="view2"
                        item-text="label"
                        item-value="value"
                        :dense="true"
                        outlined
                      >
                      </v-select>
                    </div>
                    <div class="side2 img"  v-if="view2 == 'list'" @click="view2 = 'imgs'">
                      <i class="icon"></i>
                    </div>
                    <div class="side2 table"  v-if="view2 == 'imgs'" @click="view2 = 'list'">
                      <i class="icon"></i>
                    </div>
                </div>
                <div class="space_content">
                  <div class="content_list" v-if="view2 == 'imgs'">
                    <div class="card_list">
                      <div
                        class="card_item_wrapper"
                        v-for="(item, index) in shareSpaces"
                        :key="index"
                      >
                        <div class="item">
                          <div class="grey_bg"></div>
                          <div class="top_side">
                            <img
                              src="../../assets/images/common/card_side.svg"
                              alt=""
                            />
                          </div>
                          <div class="cons">
                            <div class="top_cons">
                              <div @click="goDetail(item.workspace.id)"
                                :class="['icon_img hand', 'icon' + item.workspace.iconImageId]"></div>
                              <div class="text_wrapper">
                                <div class="tit overflow2 hand" @click="goDetail(item.workspace.id)">
                                  {{ item.workspace.name }}
                                </div>
                                <div class="bottom_cons">
                                  <div class="more_btn">
                                    <div class="item1">
                                      <v-icon>mdi-folder-open</v-icon
                                      ><span>{{ item.workspace.folderNumber }}</span>
                                    </div>
                                    <div class="item1">
                                      <v-icon>mdi-eye</v-icon
                                      ><span>{{ item.workspace.viewNumber }}</span>
                                    </div>
                                    <div class="item1">
                                      <v-icon>mdi-share</v-icon
                                      ><span>{{ item.workspace.shareNumber }}</span>
                                    </div>
                                  </div>
                                  <div class="more_point">
                                    <i class="icon"></i>
                                    <div class="pop_center_wrapper shared">
                                      <div class="list_item edit" v-if="item.permission==2"
                                        @click="editSpace1(item)">
                                        <span class="icon"></span>
                                        <span class="text">编辑</span>
                                      </div>
                                      <div class="list_item del"
                                        @click="delShared1(item.workspace.id,item.id,'user')">
                                        <span class="icon"></span>
                                        <span class="text">删除</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="bottom_cons">
                              <div class="line"></div>
                              <div class="tips_cons">
                                <span class="text1 tit_overflow">
                                  来自于{{item.shareUser.nickName}}的分享</span>
                                <span class="text">
                                  {{ item.workspace.docNumber }}条专利
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_list" v-else>
                    <v-data-table
                      item-key="id"
                      :headers="headers1"
                      :items="shareSpaces"
                      hide-default-footer
                      class="elevation-1"
                    >
                      <template v-slot:item="{headers,item}">
                          <tr>
                            <td  v-for="(item1,index1) in headers" :key="index1">
                              <div class="hand" v-if="item1.value!='actions'" @click="goDetail(item.workspace.id)">
                                <span v-if="item1.value!='nickName'">{{item.workspace[item1.value]}}</span>
                                <span v-else>{{item.shareUser[item1.value]}}</span>
                              </div>
                              <div v-else><v-icon @click="deleteSpace(item.id)">mdi-delete</v-icon></div>
                            </td>
                          </tr>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item key="3">
                <div class="space_right">
                    <div class="top_filter">
                    <div class="side1">
                        <v-select
                        :items="spaceItems"
                        label=""
                        v-model="spaceSort1"
                        @change="spaceChange1"
                        item-text="label"
                        item-value="value"
                        :dense="true"
                        outlined
                        >
                        </v-select>
                    </div>
                    <div class="side2 table"  v-if="view1 == 'list'" @click="view1 = 'imgs'">
                        <i class="icon"></i>
                    </div>
                    <div class="side2 img"  v-if="view1 == 'imgs'" @click="view1 = 'list'">
                        <i class="icon"></i>
                    </div>
                    </div>
                    <div class="space_content">
                        <div class="nav_top_wrapper">
                            <div class="left_filter">
                                <div class="sel1">
                                    <v-select
                                        :items="industryItem"
                                        label=""
                                        v-model="categoryId"
                                        item-text="label"
                                        item-value="value"
                                        :dense="true"
                                        @change="spaceChange1"
                                        outlined
                                        >
                                    </v-select>
                                </div>
                                <div class="sel2">
                                    <v-select
                                        :items="feeItem"
                                        label=""
                                        v-model="freeType"
                                        @change="spaceChange1"
                                        item-text="label"
                                        item-value="value"
                                        :dense="true"
                                        outlined
                                        >
                                    </v-select>
                                </div>
                            </div>
                            <div :class="{'right_filter': true,'active': active1}">
                            <div class="search_inputs">
                                <v-text-field
                                outlined
                                v-model="filterKey"
                                :dense="true"
                                hide-details
                                placeholder="搜索行业专题库"
                                clearable
                                @focus="active1 = true"
                                @blur="active1 = false"
                                ></v-text-field>
                            </div>
                            <span class="search_btn" @click="spaceChange1"><i class="icon"></i></span>
                            </div>
                        </div>
                        <div v-if="list1.length > 0">
                            <div class="content_list" v-if="view1 == 'imgs'">
                                <div class="card_list">
                                <div
                                    class="card_item_wrapper"
                                    v-for="(item, index) in list1"
                                    :key="index"
                                >
                                    <div class="item">
                                    <div class="cons">
                                        <div class="top_cons">
                                        <div
                                            @click="goDetail(item.id)"
                                            :class="[
                                            'icon_img',
                                            'icon' + item.iconImageId,
                                            ]"
                                        ></div>
                                        <div class="text_wrapper">
                                            <div
                                            class="tit"
                                            @click="goDetail(item.id)"
                                            >
                                            {{ item.name }}
                                            </div>
                                            <div class="bottom_cons">
                                            <div class="more_btn">
                                                <div class="item1">
                                                <v-icon>mdi-folder-open</v-icon
                                                ><span>{{
                                                    item.folderNumber
                                                }}</span>
                                                </div>
                                                <div class="item1">
                                                <v-icon>mdi-eye</v-icon
                                                ><span>{{
                                                    item.viewNumber
                                                }}</span>
                                                </div>
                                                <div class="item1">
                                                <v-icon>mdi-share</v-icon
                                                ><span>{{
                                                    item.shareNumber
                                                }}</span>
                                                </div>
                                            </div>
                                            <div class="more_point">
                                                <i class="icon"></i>
                                                <div class="pop_center_wrapper">
                                                    <!-- 
                                                        <div class="opt_icon" v-if="item.price <= 0">
                                                            <div
                                                                class="flex_style left"
                                                                v-if="mytheme.indexOf(item.id) < 0"
                                                                @click="addCollect(item)"
                                                            >
                                                                <v-icon>mdi-star-outline</v-icon><span>收藏</span>
                                                            </div>
                                                            <div
                                                                class="flex_style left"
                                                                v-if="mytheme.indexOf(item.id) > -1"
                                                                @click="cancelCollect(item)"
                                                            >
                                                                <v-icon>mdi-star</v-icon><span>取消收藏</span>
                                                            </div>
                                                        </div>
                                                    -->
                                                <div
                                                    class="list_item edit"
                                                    @click="cancelCollect1(item)"
                                                >
                                                    <span class="icon"></span>
                                                    <span class="text">取消收藏</span>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="bottom_cons">
                                        <div class="line"></div>
                                        <div class="tips_cons">
                                            <span class="text1 tit_overflow"
                                            >最新更新于{{
                                                timeFormat(item.updatedAt)
                                            }}</span
                                            >
                                            <span class="text"
                                            >{{ item.docNumber }}条专利</span
                                            >
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="content_list" v-else>
                                <v-data-table
                                item-key="id"
                                :headers="headers"
                                :items="list1"
                                hide-default-footer
                                class="elevation-1"
                                >
                                <template v-slot:item.actions="{ item }">
                                    <div v-if="item" class="icon_list">
                                    <v-icon
                                        v-if="mytheme.indexOf(item.id) > -1"
                                        @click="addCollect(item)"
                                        >mdi-star-outline</v-icon
                                    >
                                    <v-icon
                                        v-if="mytheme.indexOf(item.id) < 0"
                                        @click="cancelCollect(item)"
                                        >mdi-star</v-icon
                                    >
                                    </div>
                                </template>
                                </v-data-table>
                            </div>
                        </div>
                        <div class="default_empty" v-if="list1.length <= 0">
                            <div class="img"></div>
                            <div class="default_text">
                                暂无数据！
                            </div>
                        </div>
                    </div>
              </div>
            </v-tab-item>
            <v-tab-item key="4">
              <div class="space_right">
                <div class="top_filter">
                  <div class="side1">
                    <v-select
                      :items="spaceItems"
                      label=""
                      v-model="spaceSort2"
                      item-text="label"
                      item-value="value"
                      @change="spaceChange2"
                      :dense="true"
                      outlined
                    >
                    </v-select>
                  </div>
                  <div class="side2 table"  v-if="view4 == 'list'" @click="view4 = 'imgs'">
                    <i class="icon"></i>
                  </div>
                  <div class="side2 img"  v-if="view4 == 'imgs'" @click="view4 = 'list'">
                    <i class="icon"></i>
                  </div>
                </div>
                <div class="default_empty" v-if="libs.length <= 0">
                  <div class="img"></div>
                  <div class="default_text">
                    工作空间空空如也，去收藏内容吧！
                  </div>
                </div>
                <div class="space_content" v-if="libs.length > 0">
                  <div class="nav_top_wrapper" v-if="false">
                    <div class="left_filter">
                        <div class="sel1">
                            <v-select
                                :items="industryItem"
                                label=""
                                v-model="indusType"
                                @change="spaceChange2"
                                item-text="label"
                                item-value="value"
                                :dense="true"
                                outlined
                                >
                            </v-select>
                        </div>
                        <div class="sel2">
                            <v-select
                                :items="feeItem"
                                label=""
                                v-model="feeKey"
                                @change="spaceChange2"
                                item-text="label"
                                item-value="value"
                                :dense="true"
                                outlined
                                >
                            </v-select>
                        </div>
                    </div>
                    <div :class="{'right_filter': true,'active': active2}">
                      <div class="search_inputs" v-if="false">
                        <v-text-field
                          outlined
                          v-model="filterKey1"
                          :dense="true"
                          hide-details
                          placeholder="搜索收藏的专题库"
                          clearable
                          @focus="active2 = true"
                          @blur="active2 = false"
                        ></v-text-field>
                      </div>
                      <span class="search_btn" v-if="false" @click="spaceChange2"><i class="icon"></i></span>
                    </div>
                  </div>
                  <div class="content_list" v-if="view4 == 'imgs'">
                    <div class="card_list">
                      <div
                        class="card_item_wrapper"
                        v-for="(item, index) in libs"
                        :key="index"
                      >
                        <div class="item">
                          <div class="cons">
                            <div class="top_cons">
                              <div
                                @click="goDetail(item.workspaceId)"
                                :class="[
                                  'icon_img',
                                  'icon' + item.workspace.iconImageId,
                                ]"
                              ></div>
                              <div class="text_wrapper">
                                <div
                                  class="tit"
                                  @click="goDetail(item.workspaceId)"
                                >
                                  {{ item.workspace.name }}
                                </div>
                                <div class="bottom_cons">
                                  <div class="more_btn">
                                    <div class="item1">
                                      <v-icon>mdi-folder-open</v-icon
                                      ><span>{{
                                        item.workspace.folderNumber
                                      }}</span>
                                    </div>
                                    <div class="item1">
                                      <v-icon>mdi-eye</v-icon
                                      ><span>{{
                                        item.workspace.viewNumber
                                      }}</span>
                                    </div>
                                    <div class="item1">
                                      <v-icon>mdi-share</v-icon
                                      ><span>{{
                                        item.workspace.shareNumber
                                      }}</span>
                                    </div>
                                  </div>
                                  <div class="more_point">
                                    <i class="icon"></i>
                                    <div class="pop_center_wrapper">
                                      <div
                                        class="list_item edit"
                                        @click="cancelCollect1(item)"
                                      >
                                        <span class="icon"></span>
                                        <span class="text">取消收藏</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="bottom_cons">
                              <div class="line"></div>
                              <div class="tips_cons">
                                <span class="text1 tit_overflow"
                                  >最新更新于{{
                                    timeFormat(item.workspace.updatedAt)
                                  }}</span
                                >
                                <span class="text"
                                  >{{ item.workspace.docNumber }}条专利</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content_list" v-else>
                    <v-data-table
                      item-key="id"
                      :headers="headers4"
                      :items="libs"
                      hide-default-footer
                      class="elevation-1"
                    >
                      <template v-slot:item.actions="{ item }">
                        <div v-if="item" class="icon_list">
                          <v-icon @click="editSpace(item)">mdi-pencil</v-icon>
                          <v-icon @click="shareSpace(item)"
                            >mdi-share-variant</v-icon
                          >
                          <v-icon @click="deleteSpace(item.id)"
                            >mdi-delete</v-icon
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="addVisible" width="500">
      <v-card>
        <v-card-title class="lighten-2">{{ visibleTit }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.name"
                      label="名称"
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入名称"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="h36">
                    <v-text-field
                      v-model="form.description"
                      label="描述"
                      required
                      outlined
                      :dense="true"
                      placeholder="请输入描述"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="work_mask">
                    <span>封面</span>
                    <div class="mask_box">
                      <div :class="['img_icon', 'icon' + maskImg]"></div>
                      <i class="icon" @click="changeMasks">更换</i>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleAddCancel">取消</v-btn>
          <v-btn
            color="primary"
            @click="handleAddOk"
            v-if="visibleTit == '新建工作空间'"
          >
            确定
          </v-btn>
          <v-btn
            color="primary"
            @click="handleEditOk"
            v-if="visibleTit == '修改工作空间'"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addMask" width="500">
      <v-card>
        <v-card-title>选择封面</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="work_mask mask_icon">
            <div
              :class="['img_icon', { active: maskIndex == n }, 'icon' + n]"
              v-for="n in 8"
              :key="n"
              @click="maskIndex = n"
            ></div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleMaskCancel">取消</v-btn>
          <v-btn color="primary" @click="handleMaskOk">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="shareVisible" width="500">
      <v-card>
        <v-card-title class="lighten-2">分享工作空间</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-tabs>
            <v-tab key="1">分享到链接</v-tab>
            <v-tab key="2">分享到用户</v-tab>
            <v-tab-item key="1">
              <div class="common_tabs_wrapper">
                <div class="flex_style left">
                  <div>链接有效期</div>
                  <div style="width: 120px; height: 36px" class="marg8">
                    <v-select
                      :items="timeItem"
                      label=""
                      v-model="time"
                      item-text="label"
                      item-value="value"
                      :dense="true"
                      outlined
                    >
                    </v-select>
                  </div>
                  <v-btn color="primary" @click="shareLink">分享链接</v-btn>
                </div>
                <div class="cor_blue">{{ spaceLink }}</div>
              </div>
            </v-tab-item>
            <v-tab-item key="2">
              <div class="common_tabs_wrapper">
                <div class="flex_style left">
                  <div>用户</div>
                  <div style="width: 180px; height: 36px" class="marg8">
                    <v-text-field
                      label=""
                      v-model="userName"
                      :dense="true"
                      placeholder="请输入用户名"
                      outlined
                    >
                    </v-text-field>
                  </div>
                  <v-btn color="primary" @click="searchPeople">搜索</v-btn>
                </div>
                <div class="">
                    <v-data-table
                      item-key="id"
                      :headers="shareHeaders1"
                      :items="searchdUser"
                      disable-pagination
                      hide-default-footer
                      no-data-text="暂无数据"
                      class="common_table">
                      <template v-slot:item.permission="{item}">
                          <div class="overflow2" v-if="item">
                             <v-radio-group v-model="permission">
                                <v-radio
                                  label="可编辑"
                                  value="2"
                                ></v-radio>
                                <v-radio
                                  label="只读"
                                  value="4"
                                ></v-radio>
                              </v-radio-group>
                          </div>
                      </template>
                      <template v-slot:item.actions="{item}">
                          <div class="overflow2 hand" @click="shareToUser(item.id)">
                             分享给该用户
                          </div>
                      </template>
                   </v-data-table>
                </div>
                <div class="">
                    <v-data-table
                      item-key="id"
                      :headers="shareHeaders"
                      :items="shareHisList"
                      disable-pagination
                      no-data-text="暂无数据"
                      hide-default-footer
                      class="common_table">
                      <template v-slot:item.permission="{item}">
                        <div>
                          <span v-if="item.permission == 4">只读</span>
                          <span v-else>可编辑</span>
                        </div>
                      </template>
                      <template v-slot:item.actions="{item}">
                          <div class="overflow2 hand" v-if="item" @click="delShared(item.id,'user')">
                             删除
                          </div>
                      </template>
                   </v-data-table>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="display: flex; justify-content: flex-end">
          <v-btn @click="handleShareCancel">取消</v-btn>
          <v-btn color="primary" @click="handleShareOk">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Qs from "qs";
import template from '../../components/widgets/template.vue';
export default {
  components: { template },
  data() {
    return {
      addVisible: false,
      shareVisible: false,
      addMask: false,
      maskImg: 1,
      maskIndex: 1,
      form: {},
      mask: [],
      mask1: [],
      list: [],
      libs: [],
      shareSpaces: [],
      list1: [],
      viewItem: [
        { label: "列表", value: "list" },
        { label: "缩略图", value: "imgs" },
      ],
      spaceItems: [
          { label: "按创建时间", value: "created_at" },
          { label: "按更新时间", value: "updated_at" },
          { label: "按文档数", value: "doc_number" },
      ],
      spaceSort: 'created_at',
      spaceSort1: 'created_at',
      spaceSort2: 'created_at',
      sortKey: 'created_at',
      industryItem: [
          { label: "全部", value: 0 },
          { label: "高校与研究机构", value: 1 },
          { label: "上市公司", value: 2 },
          { label: "专利奖", value: 3 },
          { label: "国民经济分类", value: 4 },
          { label: "备案专利", value: 5 },
      ],
      indusType: 0,
      feeItem: [
          { label: "全部", value: 0 },
          { label: "免费", value: 1 },
          { label: "收费", value: 2 },
      ],
      feeKey: 0,
      view: "imgs",
      view1: "imgs",
      view2: "imgs",
      visibleTit: "新建工作空间",
      headers: [
        {
          text: "名称",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "描述",
          align: "start",
          sortable: false,
          value: "description",
        },
        {
          text: "专利数",
          align: "start",
          sortable: false,
          value: "docNumber",
        },
        {
          text: "文件数",
          align: "start",
          sortable: false,
          value: "folderNumber",
        },
        {
          text: "查看数",
          align: "start",
          sortable: false,
          value: "viewNumber",
        },
        {
          text: "分享数",
          align: "start",
          sortable: false,
          value: "shareNumber",
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
      headers1: [
        {
          text: "名称",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "描述",
          align: "start",
          sortable: false,
          value: "description",
        },
        {
          text: "专利数",
          align: "start",
          sortable: false,
          value: "docNumber",
        },
        {
          text: "文件数",
          align: "start",
          sortable: false,
          value: "folderNumber",
        },
        {
          text: "查看数",
          align: "start",
          sortable: false,
          value: "viewNumber",
        },
        {
          text: "分享数",
          align: "start",
          sortable: false,
          value: "shareNumber",
        },
        {
          text: "分享者",
          align: "start",
          sortable: false,
          value: "nickName",
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
      shareHeaders: [
        {
          text: "用户名",
          align: "start",
          sortable: false,
          value: "user.nickName",
        },
        {
          text: "所属公司",
          align: "start",
          sortable: false,
          value: "user.realCompany",
        },
        {
          text: "权限设置",
          align: "start",
          sortable: false,
          value: "permission",
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
        }
      ],
      shareHeaders1: [
        {
          text: "用户名",
          align: "start",
          sortable: false,
          value: "nickName",
        },
        {
          text: "所属公司",
          align: "start",
          sortable: false,
          value: "realCompany",
        },
        {
          text: "权限设置",
          align: "start",
          sortable: false,
          value: "permission",
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
      timeItem: [
        {
          label: "7天有效",
          value: "7",
        },
        {
          label: "14天有效",
          value: "14",
        },
        {
          label: "永久有效",
          value: "long",
        },
      ],
      time: "7",
      userName: "",
      categoryId: 0,
      freeType: 0,
      spaceInfo: {},
      spaceLink: "",
      mytheme: [],
      filterKey: "",
      view4: 'imgs',
      headers4: [
        {
          text: "名称",
          align: "start",
          sortable: false,
          value: "workspace.name",
        },
        {
          text: "描述",
          align: "start",
          sortable: false,
          value: "workspace.description",
        },
        {
          text: "专利数",
          align: "start",
          sortable: false,
          value: "workspace.docNumber",
        },
        {
          text: "文件数",
          align: "start",
          sortable: false,
          value: "workspace.folderNumber",
        },
        {
          text: "查看数",
          align: "workspace.start",
          sortable: false,
          value: "workspace.viewNumber",
        },
        {
          text: "分享数",
          align: "start",
          sortable: false,
          value: "workspace.shareNumber",
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
        spaceKey: '',
        searchKey: '',
        filterKey1: '',
        active: false,
        active1: false,
        active2: false,
        shareHisList: [],
        searchdUser: [],
        permission: 4
    };
  },
  created() {
    this.getList();
  },
  computed: {
    vertical() {
      if (
        this.$vuetify.breakpoint.name == "sm" ||
        this.$vuetify.breakpoint.name == "xs"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions("space", [
      "getSpaces",
      "newSpace",
      "delSpace",
      "getSpecials",
      "modifySpace",
      "collectSpecials",
      "removeSpecials",
      "addShare",
      "searchUserInfo",
      "getSharedSpaceList",
      "addNewSharedSpace",
      "delSharedSpace"
    ]),
    successMsg(msg) {
      this.$message({
        type: "success",
        message: msg || "操作成功!",
      });
    },
    failMsg(msg) {
      this.$message({
        type: "error",
        message: msg || "操作失败!",
      });
    },
    tabsChange(e) {
      if (e === 2) {
        this.getIndustryList();
      }
    },
    goDetail(id) {
      this.$router.push({
        path: "/workSpace/detail",
        query: {
          spaceId: id,
        },
      });
    },
    spaceChange() {
        this.sortKey = this.spaceSort
        this.searchKey = this.spaceKey
        this.getList()
    },
    spaceChange1() {
        this.getIndustryList()
    },
    spaceChange2() {
        this.sortKey = this.spaceSort2
        this.searchKey = this.filterKey1
        this.getList()
    },
    getList() {
      let _this = this;
      let data = {
        params: {
          ps: 20,
          sortBy: this.sortKey,
          key: this.searchKey,
          categoryId: this.indusType,
          freeType: this.feeKey
        },
      };
      this.getSpaces({
        data: data,
        handle(res) {
          let list = res.workspaces;
          if (list && list.length > 0) {
            list.forEach((item, index) => {
              _this.mask[index] = false;
            });
          }
          _this.list = list;
          let libs = res.recommendThemeLibs;
          _this.libs = libs;
          let shareSpaces = res.workspaceShares;
          _this.shareSpaces = shareSpaces;
        },
      });
    },
    getIndustryList() {
      let _this = this;
      let data = {
        params: {
          categoryId: this.categoryId,
          freeType: this.freeType,
          ps: 20,
          key: this.filterKey,
          s: this.spaceSort1,
        },
      };
      this.getSpecials({
        data: data,
        handle(res) {
          let list = res.pagination.data;
          _this.mytheme = res.myThemeLibIdSet;
          _this.list1 = list;
        },
      });
    },
    addNew() {
      this.addVisible = true;
      this.form = {};
      this.visibleTit = "新建工作空间";
    },
    handleAddOk() {
      let flag = false
      this.list.forEach((item)=>{
        if(item.name == this.form.name) {
            this.$message({
              type: 'info',
              message: '空间名称重复，请重新输入'
            })
            flag = true
        }
      })
      if(flag) {
        return false
      }
      this.form.iconImageId = this.maskImg;
      let data = {
        params: this.form,
      };
      let _this = this;
      this.newSpace({
        data: data,
        handle(res) {
          if (res.success) {
            _this.successMsg(res.message);
            _this.addVisible = false;
            _this.getList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    handleAddCancel() {
      this.form = {};
      this.addVisible = false;
    },
    deleteSpace(id) {
      this.$msgbox
        .confirm("此操作将永久删除该空间, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let data = {
            params: {
              workspaceId: id,
            },
          };
          let _this = this;
          this.delSpace({
            data: data,
            handle(res) {
              if (res.success) {
                _this.successMsg(res.message);
                _this.getList();
              } else {
                _this.failMsg(res.message);
              }
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editSpace(value) {
      this.addVisible = true;
      this.form = value;
      this.maskImg = value.iconImageId;
      this.visibleTit = "修改工作空间";
    },
    editSpace1(item) {
      let value = {
        id: item.workspace.id,
        name: item.workspace.name,
        description: item.workspace.description,
        iconImageId: item.workspace.iconImageId || 1,
      };
      this.addVisible = true;
      this.form = value;
      this.maskImg = value.iconImageId;
      this.visibleTit = "修改工作空间";
    },
    handleEditOk() {
      this.form.iconImageId = this.maskImg;
      let data = {
        params: {
          workspaceId: this.form.id,
          name: this.form.name,
          description: this.form.description,
          iconImageId: this.maskImg,
        },
      };
      // let data = this.form
      let _this = this;
      this.modifySpace({
        data: data,
        handle(res) {
          _this.addVisible = false;
          if (res.success) {
            _this.successMsg(res.message);
            _this.getList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    shareSpace(value) {
      this.spaceInfo = value;
      this.shareVisible = true;
      this.getShareHistory()
    },
    getShareHistory() {
      let data = {
        params: {
          workspaceId: this.spaceInfo.id
        }
      }
      let _this = this 
      this.getSharedSpaceList({data: data,handle(res){
        console.log('res', res)
          _this.shareHisList = res.workspaceShares
      }})
    },
    searchPeople() {
      let data = {
        params: {
          account: this.userName
        }
      }
      let _this = this
      this.searchUserInfo({data: data,handle(res) {
        console.log('res', res)
        _this.permission = res.user.permission || 4
         _this.searchdUser = [res.user] || []
      }})
    },
    shareToUser(id) {
      let data = {
        params: {
          type: 'user',
          userId: id,
          workspaceId: this.spaceInfo.id,
          permission: this.permission
        }
      }
      let _this = this
      this.addNewSharedSpace({data: data,handle(res) {
          console.log('res', res)
          if(res.success) {
            _this.$message({
              type: 'success',
              message: res.message
            })
            _this.shareVisible = false
            _this.shareHisList = []
            _this.searchdUser = []
            _this.userName = ''
          }else {
            _this.$message({
              type: 'info',
              message: res.message
            })
          }
      }})
    },
    delShared(id,type) {
      let data = {
        params: {
          workspaceId: this.spaceInfo.id,
          shareId: id,
          type: type
        }
      }
      let _this = this
      this.delSharedSpace({data: data,handle(res) {
          console.log('res',res)
          if(res.success) {
            _this.$message({
              type: 'success',
              message: res.message
            })
            _this.getShareHistory()
          }else {
             _this.$message({
              type: 'info',
              message: res.message
            })
          }
      }})
    },
    delShared1(id1,id2,type) {
      let data = {
        params: {
          workspaceId: id1,
          shareId: id2,
          type: type
        }
      }
      let _this = this
      this.delSharedSpace({data: data,handle(res) {
          if(res.success) {
            _this.$message({
              type: 'success',
              message: res.message
            })
            _this.getList()
          }else {
             _this.$message({
              type: 'info',
              message: res.message
            })
          }
      }})
    },
    shareLink() {
      let data = {
        params: {
          workspaceId: this.spaceInfo.id,
          type: "link",
          date: this.time,
        },
      };
      let _this = this;
      this.addShare({
        data: data,
        handle(res) {
          if (res.success) {
            _this.successMsg(res.message);
            _this.spaceLink = res.url;
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    handleShareCancel() {
      this.shareVisible = false;
    },
    handleShareOk() {
      this.shareVisible = false;
    },
    changeMask(index) {
      this.mask.splice(index, 1, !this.mask[index]);
    },
    changeMask1(index) {
      this.mask1.splice(index, 1, !this.mask1[index]);
    },
    timeFormat(unixTime) {
      let date = new Date(unixTime);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D ;
      // + h + m + s
    },
    changeMasks() {
      this.addMask = true;
    },
    handleMaskCancel() {
      this.addMask = false;
    },
    handleMaskOk() {
      this.addMask = false;
      this.maskImg = this.maskIndex;
    },
    addCollect(val) {
      let data = {
        params: {
          workspaceId: val.id,
        },
      };
      let _this = this;
      this.collectSpecials({
        data: data,
        handle(res) {
          if (res.success) {
            _this.successMsg(res.message);
            _this.getIndustryList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    cancelCollect(val) {
      let data = {
        params: {
          workspaceId: val.id,
        },
      };
      let _this = this;
      this.removeSpecials({
        data: data,
        handle(res) {
          if (res.success) {
            _this.getIndustryList();
            _this.successMsg(res.message);
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    cancelCollect1(val) {
      let data = {
        params: {
          workspaceId: val.workspaceId,
        },
      };
      let _this = this;
      this.removeSpecials({
        data: data,
        handle(res) {
          if (res.success) {
            _this.getList();
            _this.successMsg(res.message);
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
  },
};
</script>